import React, { useState } from "react";
import { ModalDialog } from "../../../../components";
import ServiceCard from "../../../../components/components/molecules/ServiceCard";
import { Button, Heading, Icon, Text } from "@telia/teddy";
import "./ServiceModal.less";
import { connect, useDispatch } from "react-redux";
import { ChangedService, RootState } from "../../../../../../models";
import { OldSubscription } from "../../../../../../models/common";
import { CheckoutSubscription } from "../../../../../../models/state";
import { addServicesToCart } from "../../../state/actions/cartActions";
import { getAllItemsOfType } from "../../../state/selectors/cartSelectors";
import {
    getChangedServices,
    getOldSubscription,
    getSubscription,
} from "../../../state/selectors/subscriptionsSelectors";

interface ServiceModalProps extends StateProps {
    onClose: () => void;
    subscriptionId: string;
}

interface StateProps {
    changedServices: ChangedService[];
    newSubscription?: CheckoutSubscription;
    oldSubscription?: OldSubscription;
    servicesInCart?: string[];
}

const ServiceModal: React.FC<ServiceModalProps> = ({
    subscriptionId,
    newSubscription,
    oldSubscription,
    changedServices,
    servicesInCart,
    onClose,
}) => {
    const [services, setServices] = useState(servicesInCart || []);

    const dispatch = useDispatch();

    const handleAddService = (service: string) => {
        const serviceToCheck = services;
        if (!serviceToCheck.includes(service)) {
            setServices([...serviceToCheck, service]);
        } else {
            serviceToCheck.splice(serviceToCheck.indexOf(service), 1);
            setServices([...serviceToCheck]);
        }
    };

    const handleSubmit = () => {
        const servicesNotAlreadyInCart = services.filter((service) => !servicesInCart?.includes(service));
        dispatch(addServicesToCart(servicesNotAlreadyInCart, subscriptionId, undefined, true));
        onClose();
    };

    const SubscriptionChange = () => (
        <div className="service-modal__subscription-change">
            <Text mb="100" id="subscription-order">
                Du er ferd med å bestille: <span className="underline">{newSubscription?.name}</span> (
                {newSubscription?.price?.monthly?.amountSubscription},-/md.)
            </Text>
            <Text mb="100" id="subscription-change">
                <Icon name="switch-arrows" />
                Endres fra: <span className="underline">{oldSubscription?.name}</span> ({oldSubscription?.price},-/md.)
            </Text>
        </div>
    );

    return (
        <ModalDialog
            size="small"
            name="service-modal"
            className="service-modal"
            onClose={() => {
                onClose();
            }}
            heading="Prisendringer av tilleggstjenester"
        >
            <SubscriptionChange />
            <div className="service-modal__disclaimer">
                <Heading mb="100" as="h2" variant="title-100">
                    <Icon name="info-filled" /> Prisendringer av tilleggstjenester
                </Heading>
                <Text mb="100">
                    Ved endring av abonnement vil inkluderte tjenester bli til betalte tjenester. Legg til tjenestene
                    under dersom du fortsatt ønsker å beholde dem.
                </Text>
            </div>
            <div className="service-modal__services">
                {changedServices.map((service, i) => (
                    <ServiceCard
                        checked={services.includes(service.oldProduct.code)}
                        onAdd={() => handleAddService(service.oldProduct.code)}
                        key={i}
                        price={service.newProduct.price.price.toString()}
                        heading={service.newProduct.shortName}
                        strikethrough={service.oldProduct.price.price.toString()}
                        description={service.newProduct.shortDescription}
                    />
                ))}
            </div>
            <div className="service-modal__button-wrapper">
                <Button variant="secondary" onClick={() => onClose()}>
                    Nei takk
                </Button>
                <Button disabled={services.length < 1} variant="primary" onClick={() => handleSubmit()}>
                    <Icon name="cart" />
                    Legg til
                </Button>
            </div>
        </ModalDialog>
    );
};

const mapStateToProps: (state: RootState, ownProps: { subscriptionId: string }) => StateProps = (
    state,
    { subscriptionId },
) => {
    return {
        changedServices: getChangedServices(state, subscriptionId),
        newSubscription: getSubscription(state, subscriptionId),
        oldSubscription: getOldSubscription(state, subscriptionId),
        servicesInCart: getAllItemsOfType(state, "SERVICE")
            .filter((service) => service.bundleId === subscriptionId)
            .map((service) => service.id),
    };
};

export default connect(mapStateToProps)(ServiceModal);
